import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, EventEmitter, HostListener, Inject, Input, Output, PLATFORM_ID } from '@angular/core';
import { isTablet } from '@digilize/shared/utils/helpers/src';

@Directive({
  selector: '[appClickOutside]',
  standalone: false,
})
export class ClickOutsideDirective {
  exceptionEl: HTMLElement | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Record<string, unknown>, private elementRef: ElementRef) {}

  @Input('exception') set Exception(el: HTMLElement) {
    this.exceptionEl = el;
  }

  @Input() mobileOnly = false;

  @Output() appClickOutside: EventEmitter<any> = new EventEmitter();

  @HostListener('document:click', ['$event.target']) onMouseClick(targetElement) {
    if (isPlatformBrowser(this.platformId)) {
      if (!this.mobileOnly || isTablet()) {
        const clickedInside =
          this.elementRef.nativeElement.contains(targetElement) || this.exceptionEl?.contains(targetElement);
        if (!clickedInside) {
          this.appClickOutside.emit(targetElement);
        }
      }
    }
  }
}
